import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import useOnclickOutside from 'react-cool-onclickoutside';
import DropdownArrow from '../../shared/dropdown/dropdown-arrow';
import {
  DropdownContainer,
  DropdownInputContainer,
  DropdownText,
  Icon,
  OptionsContainer,
  Option,
} from '../../shared/dropdown/styles';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const SDropdownInputContainer = styled(DropdownInputContainer)`
  width: 192px;
`;

const SOptionsContainer = styled(OptionsContainer)`
  width: 240px;
`;

export default function Orders({ order, onChange }) {
  const options = [
    {
      label: 'Most Followed',
      value: 'most_followed',
    },
    {
      label: 'Most Active',
      value: 'most_active',
    },
    {
      label: 'Most Viewed',
      value: 'most_viewed',
    },
    {
      label: 'Alphabetical',
      value: 'alphabetical',
    },
  ];

  const [expanded, setExpanded] = React.useState(false);
  const [selectedOption, setSelectedOption] = React.useState(
    _.find(options, ['value', order]) || options[0],
  );

  const ref = useOnclickOutside(() => {
    setExpanded(false);
  });

  const toggleExpanded = e => {
    e && e.preventDefault();
    setExpanded(!expanded);
  };

  const setOrder = option => e => {
    e && e.preventDefault();
    setSelectedOption(option);
    setExpanded(false);
    onChange(option.value);
  };

  return (
    <Container>
      <DropdownContainer ref={ref}>
        <SDropdownInputContainer onClick={toggleExpanded}>
          <Icon className="icon-lw icon-lw-order-desc" />
          <DropdownText>{selectedOption.label}</DropdownText>
          <DropdownArrow expanded={expanded} />
        </SDropdownInputContainer>
        {expanded && (
          <SOptionsContainer>
            {options.map(option => (
              <Option
                key={option.value}
                className={classNames({ selected: selectedOption.value === option.value })}
                onClick={setOrder(option)}
              >
                {option.label}
              </Option>
            ))}
          </SOptionsContainer>
        )}
      </DropdownContainer>
    </Container>
  );
}

Orders.propTypes = {
  order: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
